

<template>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="header_inn d-flex align-items-center justify-content-between">
          <div class="header_left">
            <div class="site_logo">
              <router-link to="/">
                <img :src="setLogo" alt="logo" />
              </router-link>
            </div>
            <div class="mainmenu">
              <nav id="menu">
                <ul class="dropdown">
                  <li v-for="(menu, key) in menus" :key="key">
                    <router-link v-if="menu.hasChild" :to="menu.link">{{
                      menu.title
                    }}</router-link>
                    <ul v-if="menu.hasChild && menu.data.length > 0">
                      <li v-for="(subMenu, subKey) in menu.data" :key="subKey">
                        <router-link :to="subMenu.link">{{ subMenu.title }}</router-link>
                      </li>
                    </ul>
                    <router-link v-else :to="menu.link">{{ menu.title }}</router-link>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
          <div class="header_right">
            <top-social-menu />
            <top-menu-tools />
            <top-menu-responsive />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TopSocialMenu from "./TopSocialMenu";
import TopMenuTools from "./TopMenuTools";
import TopMenuResponsive from "./TopMenuResponsive";

export default {
  name: "TopNavMenu",
  components: { TopMenuResponsive, TopMenuTools, TopSocialMenu },
  data() {
    return {
      logo: {
        black: require("../../assets/img/logo_black.png"),
        white: require("../../assets/img/logo.png"),
      },
      menus: [
        /*
        {
          title: "Home",
          link: "/",
          hasChild: false,
        },
        {
          title: "Menu",
          link: "/food-menu",
          hasChild: false,
        },
        {
          title: "Pages",
          link: "#",
          hasChild: true,
          data: [
            {
              title: "About Us",
              link: "/pages/about-us",
            },
            {
              title: "Gallery",
              link: "/pages/gallery",
            },
            {
              title: "404 Page",
              link: "/pages/404",
            },
            {
              title: "Login Page",
              link: "/pages/login",
            },
            {
              title: "Signup Page",
              link: "/pages/signup",
            },
            {
              title: "Contact",
              link: "/pages/contact",
            },
          ],
        },
        {
          title: "Shop",
          link: "#",
          hasChild: true,
          data: [
            {
              title: "Products",
              link: "/shop/products",
            },
            {
              title: "Product Details",
              link: "/shop/product-details/1",
            },
            {
              title: "Checkout",
              link: "/shop/checkout",
            },
            {
              title: "Cart",
              link: "/shop/cart",
            },
          ],
        },
        {
          title: "News",
          link: "#",
          hasChild: true,
          data: [
            {
              title: "News",
              link: "/news",
            },
            {
              title: "News Details",
              link: "/news-details",
            },
          ],
        },
        */
      ],
    };
  },
  computed: {
    setLogo() {
      if (this.$route.path === "/") {
        return this.logo.white;
      }

      return this.logo.black;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/menus/TopNavMenu.vue